
    export default 
    {
    "ad_1688": {
        "top_banner": "DSers Massenlieferantenprogramm ist live! Unterstützt durch das AliExpress, 1688 und DSers Lieferteam. Erhalten Sie 10% bis 30% Rabatt auf Produkte!",
        "learn_more": "Erfahren Sie mehr"
    }
}